import { Button, styled } from '@tools/wr-catalog-base'

export const ImgContainer = styled.div`
  width: 2em;
  height: 2em;
  margin-right: -0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledButton = styled(Button)`
  padding: 0.3rem 0.8rem !important;
  display: flex;
  align-items: center;
`
